import { css, keyframes } from 'emotion';
import { observer, useObservable } from 'mobx-react-lite';
import * as React from 'react';
import Lottie from 'react-lottie';

import loaderAnimation from '../assets/loader.json';
import { FADEOUT_ANIMATION_DURATION } from '../consts/animations';

const fadeOut = keyframes`
  0% { opacity: 1; }
  100% { opacity: 0; }
`;

const main = (isLoading: boolean, isHidden: boolean) => css`
  background: #f6f2f3;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;

  ${!isLoading && `animation: ${fadeOut} ${FADEOUT_ANIMATION_DURATION}ms ease;`}

  ${isHidden && 'display: none;'}
`;

interface ILoaderProps {
  isLoading?: boolean;
}


export const Loader = observer(({ isLoading = true }: ILoaderProps) => {
  const state = useObservable({
    isHidden: false,
  });
  const lottieOptions = {
    animationData: loaderAnimation,
    autoplay: true,
    loop: true,
  };

  function onAnimationEnd() {
    state.isHidden = true;
  }

  return (
    <div className={main(isLoading, state.isHidden)} onAnimationEnd={onAnimationEnd}>
      <Lottie width={250} options={lottieOptions} />
    </div>
  );
});
